import { InfrastructureError, PresentableError } from '@goodt-wcore/errors';

export const DremioErrorMessages = {
    CANCEL: 'Загрузка данных была отменена',
    COMMON: 'Не удалось загрузить данные с сервера'
};

export class DremioError extends InfrastructureError {
    context;

    static createFromSDKError(sdkError) {
        const { message, ...restErrorData } = sdkError;
        return new DremioError(message, restErrorData);
    }

    constructor(message, ...rest) {
        super(message, ...rest);
        this.name = 'DremioError';
    }
}

/**
 *
 */
export class DremioPresentableError extends PresentableError {

    _reason;

    static createFromDremioError(dremioError, { message } = {}) {
        const { code } = dremioError;

        const messages = [message ?? DremioErrorMessages.COMMON];
        if (code === 401) {
            messages.push(': отсутствует аутентификация.');
        }
        if (code === 500) {
            messages.push(': при обработке запроса сервером возникла ошибка.');
        }

        const presentableError = new DremioPresentableError(messages.join(''), { reason: dremioError });

        return presentableError;
    }

    constructor(message, { reason } = {}) {
        super(message);
        this.name = 'DremioPresentableError';
        this._reason = reason;
    }

    toDebugString() {
        const { reason } = this;
        const str = super.toString();
        return reason != null ? `${str}\n${reason}` : str;
    }

    get reason() {
        return this._reason;
    }

    /**
     *
     * @param context
     */
    setContext(context) {
        if (this._reason == null) {
            return;
        }
        if ('context' in this._reason === false) {
            return;
        }

        this._reason.context = context;
    }
}
